/* eslint-disable prefer-const */
/* eslint-disable prettier/prettier */
/* eslint-disable import/no-unresolved */
import {
  Container,
  Stack,
  Typography,
  Button,
  Icon,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon
} from '@mui/material';
import React, { useState } from 'react';
import Page from 'src/components/Page';
import { Link as RouterLink } from 'react-router-dom';
import skipBackOutline from '@iconify/icons-eva/skip-back-outline';
import MyDropzone from 'src/components/MyDropzone';
import axios from 'axios';
import SaveIcon from '@mui/icons-material/Save';
import { config } from 'src/helpers/config';
import authHeader from 'src/helpers/authHeader';
import { NotificationManager } from 'react-notifications';

export default function Gallery() {
  const [files, setFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState([]);

  const updateGallery = () => {
    const formData = new FormData();
    files.map((file) => formData.append('images', file));

    axios
      .post(`${config.apiAdminUrl}adminGallery`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...authHeader()
        }
      })
      .then(() => {
        NotificationManager.success('Wizyta została dodana!', '', 3000);
      })
      .catch((e) =>
        NotificationManager.error('Wystąpił jakiś błąd! Skontaktuj się z Łukaszem!', '', 3000)
      );
  };

  return (
    <Page title="Galeria">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Wizyta
          </Typography>
          <span>
            <Button
              sx={{
                marginRight: '5px'
              }}
              variant="contained"
              component={RouterLink}
              to="/dashboard"
              startIcon={<Icon icon={skipBackOutline} />}
            >
              Wróć
            </Button>
          </span>
        </Stack>
        <MyDropzone
          multiple
          files={files}
          handleFiles={(e) => setFiles(e)}
          handleDeletedFiles={(e) => {
            let _deletedFiles = deletedFiles;
            _deletedFiles.push(e);
            setDeletedFiles(_deletedFiles);
          }}
        />
      </Container>
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          component={Button}
          type="button"
          onClick={() => updateGallery()}
          icon={<SaveIcon />}
          tooltipTitle="Zapisz"
        />
      </SpeedDial>
    </Page>
  );
}
